export default "__VITE_ASSET__qc34GJai__"